// @flow
import * as React from 'react';
import type { FieldConfig } from './FieldConfig';
import { Select } from 'components';
import styles from './Field.scss';
import RatingRange from './RatingRange';
import { fieldDefault } from './fieldUtils';
import DatePicker from './DatePicker';

type Props = FieldConfig & {
  onChange: ({ name: string, value: any }) => void,
  value: *,
  className?: string,
};

const Field = (props: Props) => {
  const {
    name,
    label,
    type,
    value: rawValue,
    placeholder = '',
    onChange,
    className = '',
    attributes = {},
    style,
  } = props;
  let input;
  const value = fieldDefault(type, rawValue);

  if (type === 'hidden') {
    return <input type={type} name={name} value={props.defaultValue} />;
  }

  if (
    !input &&
    (type === 'select' || type === 'multiselect') &&
    props.options != null
  ) {
    const options = props.options;

    input = (
      <Select
        options={options}
        name={name}
        // id={name}
        instanceId={name}
        inputProps={{
          'data-id': name,
          id: name,
        }}
        value={value}
        multi={type === 'multiselect'}
        clearable={true}
        disabled={options.length === 0}
        placeholder={placeholder}
        onChange={value => onChange({ name, value })}
      />
    );
  }

  if (!input && type === 'RatingRange' && Array.isArray(value)) {
    input = (
      <RatingRange
        name={name}
        value={value}
        onChange={value => onChange({ name, value })}
      />
    );
  }

  if (!input && type === 'date') {
    input = (
      <DatePicker
        name={name}
        // $$FlowFixMe
        value={value}
        onChange={value => onChange({ name, value })}
        //className={`${styles.fieldInput} ${className}`}
        {...attributes}
      />
    );
  }

  if (!input) {
    input = (
      <input
        type={type}
        name={name}
        value={value}
        className={`${styles.fieldInput} ${className}`}
        onChange={({ currentTarget: { value } }) => onChange({ name, value })}
        {...attributes}
      />
    );
  }

  return (
    <div className={styles.field} style={style}>
      {label && (
        <label htmlFor={name} className={styles.fieldLabel}>
          {label}
        </label>
      )}
      {label === 'Catalog' ? <div data-translate={false}>{input}</div> : input}
    </div>
  );
};

export default Field;



// WEBPACK FOOTER //
// ./src/containers/search/SearchForm/Field.js